import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import classnames from "classnames";
import { Box, IconButton, Link } from "@material-ui/core";
import Icon from "@mdi/react";

//icons
import {
  mdiFacebook as FacebookIcon,
  mdiTwitter as TwitterIcon,
  mdiGithub as GithubIcon,
} from "@mdi/js";

// styles
import useStyles from "./styles";

// components
import Header from "../StudentHeader";
import StudentSidebar from "../Sidebar/StudentSidebar";

// pages
import Dashboard from "../../pages/StudentDashboard/StudentDashboard";
import Tables from "../../pages/tables/Tables";

import pdfboard from "../../pages/pdfboard/StudentDashboard"
import pdfs11 from "../../pages/pdf11/StudentDashboard"
import pdfs12 from "../../pages/pdf12/StudentDashboard"
import videoboard from "../../pages/videoboard/StudentDashboard";
import video11 from "../../pages/video11/StudentDashboard";
import video12 from "../../pages/video12/StudentDashboard";
import VideoRev from '../../pages/videoRev/StudentDashboard'
import videoGMP from "../../pages/videoGMP/StudentDashboard"
import PdfViewer from '../../pages/PdfViewer/PdfViewer'
import videoPlayer from "../../pages/videoPlayer/videoPlayer";

// context
import { useLayoutState } from "../../context/LayoutContext";

function StudentLayout(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div onContextMenu={(e) => e.preventDefault()} className={classes.root}>
      <>
        <Header history={props.history} />
        <StudentSidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <Switch>
            <Route path="/student/studentdashboard" component={Dashboard} />
            <Route path="/student/pdfboard" component={pdfboard} />
            <Route path="/student/pdf11" component={pdfs11} />
            <Route path="/student/pdf12" component={pdfs12} />

            <Route path="/student/viewpdf" component={PdfViewer} />
            
            <Route path="/student/videoboard" component={videoboard} />
            <Route path="/student/video11" component={video11} />
            <Route path="/student/video12" component={video12} />
            <Route path="/student/videoRev" component={VideoRev} />
            <Route path="/student/videoGMP" component={videoGMP} />

            <Route path="/student/videoPlayer" component={videoPlayer} />           
          </Switch>
          
        </div>
      </>
    </div>
  );
}

export default withRouter(StudentLayout);
